import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// NativeDateAdapter.getFirstDayOfWeek() renvoie toujours 0 (dimanche),
// peu importe la locale (limitation connue d'Angular Material).
@Injectable()
export class MondayDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}
